<template>
    <div class="company-info">
        <div class="company-info-title">
            {{obj.companyname}}
        </div>

        <div>
            <span class="icon-span"><font-awesome-icon icon="fa-solid fa-location-dot" /></span>&nbsp;<span>{{countryname}}</span>
        </div>

        <div class="shop-info">
            <div>
                <span tkey="店鋪位置">{{i18n.tkey("lang_shop_position")}}</span>：{{obj.wa}}-{{obj.siojournal}}
            </div>

            <div>
                <el-button type="primary" text @click="goShopEvent" tkey="去店查看">{{i18n.tkey("lang_go_shop_view")}}</el-button>
            </div>
        </div>
    </div>
</template>

<script setup>

    import {computed, inject, toRef} from "vue";
    //导入图标
    import { library } from '@fortawesome/fontawesome-svg-core'
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
    import { faLocationDot } from '@fortawesome/free-solid-svg-icons'
    import {useUserinfo} from "@/stores/userinfo";
    import {getCountryObj} from "@/util/countrycode";

    library.add(faLocationDot)

    const emits = defineEmits(['click-go-shop'])
    const props = defineProps(['obj'])

    const userInfoRef = toRef(useUserinfo())
    const i18n = inject("i18n")

    const countryname = computed(() => {
        const obj = getCountryObj(props.obj.countrycode)
        let name = obj[userInfoRef.value.lang]

        return name
    })

    function goShopEvent() {
        emits("click-go-shop", props.obj.wa, props.obj.siojournal, props.obj.islandid)
    }
</script>

<style scoped>
    .company-info {
        line-height: 2;
        border: 1px #DCDFE6 solid;
        padding: 10px;
        box-sizing: border-box;
        border-radius: 5px;
        text-align: left;
    }

    .company-info:nth-child(even) {
        background: #f9f9f9;
    }

    .company-info-title {
        text-align: left;
        font-weight: 600;
    }

    .shop-info {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .icon-span {
        color: #79bbff;
    }
</style>